import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling. Respects reduced-motion preferences.
export function useLenis() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Pause smooth scrolling while a modal overlay (dialog/drawer/lightbox)
    // is open so wheel + touch gestures stay on the overlay.
    const overlayObserver = new MutationObserver(() => {
      const openOverlay = document.querySelector('[role="dialog"][data-state="open"]');
      if (openOverlay) lenis.stop();
      else lenis.start();
    });
    overlayObserver.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ["data-state"],
    });

    // Anchor links -> lenis smooth scroll
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -90, duration: 1.4 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      overlayObserver.disconnect();
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);
}